import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    recurringTasks: [],
    recurringTask: {}
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    bindAllRecurrentTasks: firestoreAction(context => {
      return context.bindFirestoreRef(
        "recurringTasks",
        db
          .collection("recurringTasks")
          .where("disabled", "==", false)
          .orderBy("dateCreated", "desc")
      );
    }),
    bindRecurringTasks: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "recurringTasks",
        db
          .collection("recurringTasks")
          .where("equipmentProfile", "==", db.doc(`equipments/${id}`))
          .where("disabled", "==", false)
          .orderBy("dateCreated", "desc")
      );
    }),
    bindARecurringTask: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "recurringTask",
        db.collection("recurringTasks").doc(id)
      );
    })
  },
  getters: {}
};
